import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-body p-9 pb-12" }
const _hoisted_5 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_6 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "card-title m-0" }
const _hoisted_16 = { class: "card-body p-9 pb-12" }
const _hoisted_17 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_18 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "card-title m-0" }
const _hoisted_28 = { class: "card-body p-9 pb-12" }
const _hoisted_29 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_30 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "d-flex justify-content-end" }
const _hoisted_40 = {
  key: 3,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_41 = { class: "card-header" }
const _hoisted_42 = { class: "card-title m-0" }
const _hoisted_43 = { class: "card-body p-9 pb-12" }
const _hoisted_44 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_45 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "d-flex justify-content-end" }
const _hoisted_55 = {
  key: 4,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_56 = { class: "card-header" }
const _hoisted_57 = { class: "card-title m-0" }
const _hoisted_58 = { class: "card-body p-9 pb-12" }
const _hoisted_59 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_60 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "d-flex justify-content-end" }
const _hoisted_70 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_71 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_75 = { key: 1 }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "d-flex justify-content-end" }
const _hoisted_81 = {
  key: 5,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_82 = { class: "card-header" }
const _hoisted_83 = { class: "card-title m-0" }
const _hoisted_84 = { class: "card-body p-9 pb-12" }
const _hoisted_85 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_86 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { key: 0 }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_90 = { key: 1 }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { key: 0 }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactCard = _resolveComponent("ContactCard")!
  const _component_RegistrationCard = _resolveComponent("RegistrationCard")!
  const _component_WarehouseCard = _resolveComponent("WarehouseCard")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_InventoryCard = _resolveComponent("InventoryCard")!
  const _component_BillingCard = _resolveComponent("BillingCard")!
  const _component_FinancialCard = _resolveComponent("FinancialCard")!
  const _component_TaxCard = _resolveComponent("TaxCard")!
  const _component_RejectModal = _resolveComponent("RejectModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (!_ctx.isNullData(_ctx.contactView))
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.contactInformation.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ContactCard, {
                type: _ctx.getKycCommonTypeParams.entityType,
                data: _ctx.contactView
              }, {
                "after-title": _withCtx(() => [
                  (_ctx.contactView.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(_ctx.contactView.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.buttonShowControl(_ctx.contactView).reject)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light-danger",
                          "data-bs-target": "#modal_reject_kyc_confirmation",
                          "data-bs-toggle": "modal",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                  _ctx.onRejectClick(_ctx.contactView.id, _ctx.CardComponentsType.Contact)
                ))
                        }, [
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                _hoisted_8,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Reject"))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.buttonShowControl(_ctx.contactView).approve)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (
                  _ctx.onApproveClick(_ctx.contactView.id, _ctx.CardComponentsType.Contact)
                ))
                        }, [
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                _hoisted_11,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, "Approve"))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["type", "data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Contact]]
          ])
        : _createCommentVNode("", true),
      (!_ctx.isNullData(_ctx.registrationView))
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.registrationInformation.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_RegistrationCard, {
                type: _ctx.getKycCommonTypeParams.entityType,
                data: _ctx.registrationView
              }, {
                "after-title": _withCtx(() => [
                  (_ctx.registrationView.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(_ctx.registrationView.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.buttonShowControl(_ctx.registrationView).reject)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light-danger",
                          "data-bs-target": "#modal_reject_kyc_confirmation",
                          "data-bs-toggle": "modal",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (
                  _ctx.onRejectClick(
                    _ctx.registrationView.id,
                    _ctx.CardComponentsType.Registration
                  )
                ))
                        }, [
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21, "Reject"))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.buttonShowControl(_ctx.registrationView).approve)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.onApproveClick(
                    _ctx.registrationView.id,
                    _ctx.CardComponentsType.Registration
                  )
                ))
                        }, [
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, "Approve"))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["type", "data"])
            ])
          ])), [
            [_directive_loading, 
        _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Registration]
      ]
          ])
        : _createCommentVNode("", true),
      (_ctx.warehouseList.length > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.warehouseInformation.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouseList, (item, index) => {
                return (_openBlock(), _createBlock(_component_WarehouseCard, {
                  key: index,
                  type: _ctx.getKycCommonTypeParams.entityType,
                  data: item,
                  index: 
            index +
            (_ctx.warehousePagination.page - 1) * _ctx.warehousePagination.rowsPerPage
          
                }, {
                  "after-title": _withCtx(() => [
                    (item.identification.kyc_level)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      (_ctx.buttonShowControl(item).reject)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-light-danger",
                            "data-bs-target": "#modal_reject_kyc_confirmation",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.onRejectClick(item.id, _ctx.CardComponentsType.Warehouse))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                  _hoisted_33,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_34, "Reject"))
                          ], 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      (_ctx.buttonShowControl(item).approve)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.onApproveClick(item.id, _ctx.CardComponentsType.Warehouse))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                  _hoisted_37,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_38, "Approve"))
                          ], 8, _hoisted_35))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["type", "data", "index"]))
              }), 128)),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.warehousePagination.page,
                  "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.warehousePagination.page) = $event)),
                  onCurrentChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Warehouse))),
                  "page-size": _ctx.warehousePagination.rowsPerPage,
                  "pager-count": 5,
                  layout: "prev, pager, next",
                  total: _ctx.warehousePagination.total,
                  "hide-on-single-page": true,
                  background: ""
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Warehouse]]
          ])
        : _createCommentVNode("", true),
      (
        _ctx.getKycCommonTypeParams.entityType === _ctx.KycType.Natural &&
        _ctx.inventoryList.length > 0
      )
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.inventoryInformation.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventoryList, (item, index) => {
                return (_openBlock(), _createBlock(_component_InventoryCard, {
                  key: index,
                  type: _ctx.getKycCommonTypeParams.entityType,
                  data: item,
                  index: 
            index +
            (_ctx.inventoryPagination.page - 1) * _ctx.inventoryPagination.rowsPerPage
          
                }, {
                  "after-title": _withCtx(() => [
                    (item.identification.kyc_level)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      (_ctx.buttonShowControl(item).reject)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-light-danger",
                            "data-bs-target": "#modal_reject_kyc_confirmation",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.onRejectClick(item.id, _ctx.CardComponentsType.Inventory))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                  _hoisted_48,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_49, "Reject"))
                          ], 8, _hoisted_46))
                        : _createCommentVNode("", true),
                      (_ctx.buttonShowControl(item).approve)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.onApproveClick(item.id, _ctx.CardComponentsType.Inventory))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                  _hoisted_52,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_53, "Approve"))
                          ], 8, _hoisted_50))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["type", "data", "index"]))
              }), 128)),
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.inventoryPagination.page,
                  "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inventoryPagination.page) = $event)),
                  onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Inventory))),
                  "page-size": _ctx.inventoryPagination.rowsPerPage,
                  "pager-count": 5,
                  layout: "prev, pager, next",
                  total: _ctx.inventoryPagination.total,
                  "hide-on-single-page": true,
                  background: ""
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Inventory]]
          ])
        : _createCommentVNode("", true),
      (_ctx.billingList.length > 0 || _ctx.financialList.length > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.financialInformation.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingList, (item, index) => {
                return (_openBlock(), _createBlock(_component_BillingCard, {
                  key: index,
                  type: _ctx.getKycCommonTypeParams.entityType,
                  data: item,
                  index: 
            index + (_ctx.billingPagination.page - 1) * _ctx.billingPagination.rowsPerPage
          
                }, {
                  "after-title": _withCtx(() => [
                    (item.identification.kyc_level)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_60, [
                      (_ctx.buttonShowControl(item).reject)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-light-danger",
                            "data-bs-target": "#modal_reject_kyc_confirmation",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.onRejectClick(item.id, _ctx.CardComponentsType.Billing))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                                  _hoisted_63,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_64, "Reject"))
                          ], 8, _hoisted_61))
                        : _createCommentVNode("", true),
                      (_ctx.buttonShowControl(item).approve)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.onApproveClick(item.id, _ctx.CardComponentsType.Billing))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                                  _hoisted_67,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_68, "Approve"))
                          ], 8, _hoisted_65))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["type", "data", "index"]))
              }), 128)),
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.billingPagination.page,
                  "onUpdate:current-page": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.billingPagination.page) = $event)),
                  onCurrentChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Billing))),
                  "page-size": _ctx.billingPagination.rowsPerPage,
                  "pager-count": 5,
                  layout: "prev, pager, next",
                  total: _ctx.billingPagination.total,
                  "hide-on-single-page": true,
                  background: ""
                }, null, 8, ["current-page", "page-size", "total"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.financialList, (item, index) => {
                return (_openBlock(), _createBlock(_component_FinancialCard, {
                  key: index,
                  type: _ctx.getKycCommonTypeParams.entityType,
                  data: item,
                  index: 
            index +
            (_ctx.financialPagination.page - 1) * _ctx.financialPagination.rowsPerPage
          
                }, {
                  "after-title": _withCtx(() => [
                    (item.identification.kyc_level)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_71, [
                      (_ctx.buttonShowControl(item).approve)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-light-danger",
                            "data-bs-target": "#modal_reject_kyc_confirmation",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.onRejectClick(item.id, _ctx.CardComponentsType.Financial))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                                  _hoisted_74,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_75, "Reject"))
                          ], 8, _hoisted_72))
                        : _createCommentVNode("", true),
                      (_ctx.buttonShowControl(item).approve)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.onApproveClick(item.id, _ctx.CardComponentsType.Financial))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                  _hoisted_78,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_79, "Approve"))
                          ], 8, _hoisted_76))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["type", "data", "index"]))
              }), 128)),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.financialPagination.page,
                  "onUpdate:current-page": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.financialPagination.page) = $event)),
                  onCurrentChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Financial))),
                  "page-size": _ctx.financialPagination.rowsPerPage,
                  "pager-count": 5,
                  layout: "prev, pager, next",
                  total: _ctx.financialPagination.total,
                  "hide-on-single-page": true,
                  background: ""
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ])
          ])), [
            [_directive_loading, 
        _ctx.loading ||
        _ctx.cardComponentsLoading[_ctx.CardComponentsType.Billing] ||
        _ctx.cardComponentsLoading[_ctx.CardComponentsType.Financial]
      ]
          ])
        : _createCommentVNode("", true),
      (_ctx.taxList.length > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.taxInformation.title")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxList, (item, index) => {
                return (_openBlock(), _createBlock(_component_TaxCard, {
                  key: index,
                  type: _ctx.getKycCommonTypeParams.entityType,
                  data: item,
                  index: index + (_ctx.taxPagination.page - 1) * _ctx.taxPagination.rowsPerPage
                }, {
                  "after-title": _withCtx(() => [
                    (item.identification.kyc_level)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_86, [
                      (_ctx.buttonShowControl(item).reject)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-light-danger",
                            "data-bs-target": "#modal_reject_kyc_confirmation",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.onRejectClick(item.id, _ctx.CardComponentsType.Tax))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_88, [
                                  _hoisted_89,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_90, "Reject"))
                          ], 8, _hoisted_87))
                        : _createCommentVNode("", true),
                      (_ctx.buttonShowControl(item).approve)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.onApproveClick(item.id, _ctx.CardComponentsType.Tax))
                          }, [
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                                  _hoisted_93,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_94, "Approve"))
                          ], 8, _hoisted_91))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["type", "data", "index"]))
              }), 128)),
              _createElementVNode("div", _hoisted_95, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.taxPagination.page,
                  "onUpdate:current-page": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.taxPagination.page) = $event)),
                  onCurrentChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Tax))),
                  "page-size": _ctx.taxPagination.rowsPerPage,
                  "pager-count": 5,
                  layout: "prev, pager, next",
                  total: _ctx.taxPagination.total,
                  "hide-on-single-page": true,
                  background: ""
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Tax]]
          ])
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_RejectModal, {
      id: _ctx.rejectId,
      onUpdateOverview: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateCardInfo(_ctx.updateType)))
    }, null, 8, ["id"])
  ], 64))
}